<template>
  <div class="detail-page" v-if="isLoadingCheck">
    <top-bar></top-bar>
    <default-layout
      :lbl="lbl"
      :locale="locale"
      :isLogin="isLogin"
      :campaign="campaign"
      v-if="isLoaded"
    ></default-layout>

    <modal view="detail" :busModal="busModal"></modal>
  </div>
</template>

<script>
import Vue from "vue";
import Account from "@/helper/AccountHelper.js";
import BzbsCampaign from "@/service/BzbsCampaign.js";
import Locale from "@/helper/locale/locale.js";
import TopBar from "@/components/TopBar.vue";

import DefaultLayout from "@/components/campaign/layout/Default.vue";
import { CampaignConfigBuilder } from "@/service/config/CampaignConfigModel.js";
import Modal from "@/components/modal/Modal.vue";
import { TrackingService } from "@/helper/TrackingHelper.js";
import Util from "@/helper/Utility.js"

export default {
  name: "Detail",
  props: {
    view: String,
  },
  components: {
    TopBar,
    DefaultLayout,
    Modal,
  },
  data: function () {
    return {
      isLogin: false,
      lbl: Locale.getLbl(),
      locale: Locale.getLocaleCode(),
      isLoaded: false,

      campaignId: "",
      campaign: null,
      campaignConfig: null,
      redeemKey: "",
      isLoadingCheck: false,

      busModal: new Vue(),
      tracking: new TrackingService(this),
    };
  },
  created: async function () {
    if (await this.checkMaintenance()) {
        console.log("checkMaintenance TRUE")
        return
    }
    Account.loginStatus().then((status) => {
        this.isLogin = status;
        if (status) {
            this.objProfile = Account.getCacheProfile();
        } else {

            Account.setCacheCustom("fromsystem", true);
            window.location.replace('/linelogin');
        }
    });
    this.tracking.screenName("campaign_detail");

    this.redeemKey = this.$route.params.redeemKey;
    this.initialConfig();
    this.getCampaign();
  },
  mounted: function () {},
  methods: {
    initialConfig: function () {
      this.campaignId = this.$route.params.campaignId;
      this.campaignConfig = new CampaignConfigBuilder()
        .setCampaignId(this.campaignId)
        .create();
    },

    getCampaign: function () {
      var strBzbsToken = Account.getToken();

      BzbsCampaign.apiGetCampaignDetail(strBzbsToken, this.campaignConfig)
        .then((data) => {
          this.campaign = data;
          this.tracking.event("campaign_detail", "view_campaign_detail", this.campaign.id+"|"+this.campaign.name);
          this.isLoaded = true;
        })
        .catch((error) => {
          if (!error.response) {
            this.busModal.$emit("showAlertModal", this.$configModalNoConnect);
          }
          console.log(error);
        });
    },
    showErrorInternet: function () {
      var configModal = {
        title: null,
        message: "พบปัญหาการเชื่อมต่อ",
        strBtnOk: "ปิด",
        tag: "nointernet",
      };
      this.busModal.$emit("showAlertModal", configModal);
    },
    checkMaintenance: function () {
        console.log("checkMaintenance")
        let StartDateMaintenance = window.StartDateMaintenance;
        let EndDateMaintenance = window.EndDateMaintenan    
        // StartDateMaintenance = "2024-02-19 15:00:00"
        // EndDateMaintenance = "2024-02-19 15:08:00"
        if (Util.isEmptyStr(StartDateMaintenance) || Util.isEmptyStr(EndDateMaintenance)) {
            this.isLoadingCheck = true;
            console.log("checkMaintenance ISEMPTY")
            return false;
        } else {
            var stDate = new Date(StartDateMaintenance)
            var edDate = new Date(EndDateMaintenance)
            var today = new Date()
            if ( today > stDate && today < edDate)
            {
                window.location.replace('/maintenance');
                return true;
            }
            this.isLoadingCheck = true;
            return false;
        }


    }
  },
};
</script>
